import script from "./es-dashboard-component.vue?vue&type=script&setup=true&lang=js"
export * from "./es-dashboard-component.vue?vue&type=script&setup=true&lang=js"

import "./es-dashboard-component.vue?vue&type=style&index=0&id=50307292&lang=scss"

const __exports__ = script;

export default __exports__